import { buildSearch as buildCommerceSearch } from "https://static.cloud.coveo.com/shopify/v1/headless.esm.js";
import { initializeBindings } from "https://static.cloud.coveo.com/atomic/v3.20.4/index.esm.js";

class CommerceAnnouncer extends HTMLElement {
  announcer;
  bindings;
  summary;
  pagination;
  didInitialLoad = false;
  previousPage = 0;
  unsubscribe = () => {};

  async connectedCallback() {
    this.createAnnouncer();

    try {
      await customElements.whenDefined("atomic-commerce-interface");
      const commerceInterface = document.querySelector(
        "atomic-commerce-interface"
      );
      if (!commerceInterface) {
        throw new Error("atomic-commerce-interface not found on the page.");
      }

      this.bindings = await initializeBindings(commerceInterface);
      this.initializeSearchController();
    } catch (error) {
      console.error("CommerceAnnouncer failed to initialize:", error);
    }
  }

  initializeSearchController() {
    const search = buildCommerceSearch(this.bindings.engine);
    this.summary = search.summary();
    this.pagination = search.pagination();

    this.unsubscribe = search.subscribe(() => {
      const state = search.state;
      const isSearchComplete = !state.isLoading && state.error === null;

      if (!isSearchComplete || !this.summary.state.firstRequestExecuted) {
        return;
      }

      if (this.summary.state.firstRequestExecuted && !this.didInitialLoad) {
        const message = `Search results are loaded.`;
        this.announce(message);
        this.didInitialLoad = true;
        return;
      }

      const currentPage = this.pagination.state.page;

      if (currentPage > 0 && currentPage !== this.previousPage) {
        const message = `Search results are loaded for page ${
          currentPage + 1
        }.`;
        this.announce(message);
      }

      this.previousPage = currentPage;
    });
  }

  disconnectedCallback() {
    this.unsubscribe();

    if (this.announcer) {
      this.announcer.remove();
    }
  }

  createAnnouncer() {
    const announcer = document.createElement("div");
    announcer.id = "commerce-announcer-live-region";
    announcer.setAttribute("aria-live", "polite");
    announcer.setAttribute("role", "status");
    announcer.setAttribute("aria-atomic", "true");
    Object.assign(announcer.style, {
      position: "absolute",
      width: "1px",
      height: "1px",
      margin: "-1px",
      padding: "0",
      overflow: "hidden",
      clip: "rect(0, 0, 0, 0)",
      whiteSpace: "nowrap",
      border: "0",
    });
    document.body.appendChild(announcer);
    this.announcer = announcer;
  }

  announce(message) {
    if (this.announcer) {
      this.announcer.innerHTML = "&nbsp;";
      setTimeout(() => {
        console.log(`📢 Announcing: "${message}"`);
        this.announcer.textContent = message;
      }, 150);
    }
  }
}

customElements.define("commerce-announcer", CommerceAnnouncer);